import React, { useEffect, useState } from 'react'
import { HeaderTable } from '../../HeaderTable'
import Pagination from '../../ui/Pagination'
import DataTable from 'react-data-table-component'
import { IoTrashOutline } from 'react-icons/io5'
import { BsPencil } from 'react-icons/bs'
import axios from 'axios'
import ModalEdit from '../../ModalEdit'
import ModalNewCase from './ModalNewCase'
import toast from 'react-hot-toast'

const Case = () => {
  const GET_DELETE = 'admin/qualification/packages'
  const GET_URL = 'admin/qualification/packages_filter'
  // const GET_URL = 'admin/qualification/init_package_qul_ids'
  const URL_EXCLE = ''
  const [modalIsOpen, setModalIsOpen] = useState("");
  const [id, setId] = useState("");
  // const [fetchData, setFetchData] = useState([])
  const [fetchData, setFetchData] = useState([])
  const [loading, setloading] = useState(false)
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1)
  const [dataFillter, setDataFillter] = useState({})
  const getCases = async (page) => {

    await axios.get(GET_URL, {
      params: {
        ...dataFillter,
        "page": page
        , "size": perPage,
        "sortName": "startDate",
      }
    })
      .then(response => {
        console.log(response?.data)
        setFetchData(response?.data)
        setTotalRows(response?.data?.length);
      })
    setloading(false)

  }
  useEffect(() => {
    getCases(currentPage - 1)
  }, [currentPage, perPage,
    // dataFillter
  ])



  const columns = [
    {
      name: "פעולות",

      cell: row => <div className='flex'>
        {/* <button title="שכפול שורה" className=' border border-gray-500 ml-1 p-1 opacity-25 hover:opacity-100' onClick={() => {
                          duplicated_qualification_details(row?.id)
                        }}><MdContentCopy /></button> */}


        {/* <button title="עוד אפשרויות" className=' border border-gray-500 ml-1 p-1 opacity-25 hover:opacity-100' onClick={() => {
                            setId(row)
                            setModalIsOpen("MoreOptions")
                        }}><MdAssignment /></button> */}


        <button title="מחיקה" className=' border border-gray-500 ml-1 p-1 opacity-15 hover:opacity-100' onClick={() => {
          setId(row)
          setModalIsOpen("Delete")
        }}><IoTrashOutline /></button>

        <button className=' border border-gray-500 ml-1 p-1 opacity-15 hover:opacity-100' onClick={() => {
          // setnamecalss(row?.description)
          // setAction("edit")
          setId(row)
          // console.log(row)
          setModalIsOpen("Edit")
        }
        }><BsPencil /></button>
      </div>,
      style: {
        fontSize: '10px',
        justifyContent: 'center',

      },
      grow: 3,


    },



    {
      name: "מחיר",
      grow: 3,
      cell: (row) => row?.price ? `${row?.price}₪` : "0₪",
      style: {
        fontSize: '10px',
        justifyContent: 'center',
        // width: '100px'
      },



    },
    {
      name: "מספר מארז",
      grow: 3,
      cell: (row) => row?.number,
      style: {
        fontSize: '10px',
        justifyContent: 'center',
        // width: '100px'
      },



    },
    {
      name: "שם מארז",
      grow: 3,
      cell: (row) => row?.name,
      style: {
        fontSize: '10px',
        justifyContent: 'center',
      },

    },





  ];
  const handlePageChange = (page) => {
    // fetchUsers(page);
    // getData(page);
    setCurrentPage(page);
  };
  const customStyles = {
    table: {
      style: {
        border: "1px solid black", // גבולות לטבלה כולה
      },
    },
    header: {
      style: {

        justifyContent: 'center',

      },
    },
    id: {
      style: {
        '&:2': { backgroundColor: '#EEEEEE' },
      }
    },
    headRow: {
      style: {
        justifyContent: 'center',
        //  borderTopWidth: '1px',

        // borderTopColor: defaultThemes.default.divider.default,
      },
    },
    headCells: {
      style: {
        '&:not(:last-of-type)': { borderRight: "1px solid black" }, // גבולות בין תאים
        // whiteSpace: 'normal',
        // overflow: 'visible',
        // textOverflow: 'clip',
        // maxWidth: 'none', // Allow headers to expand as needed
        // padding: '10px'
        // ,
        // borderBottom: "1px solid black", // גבולות לכותרת הטבלה

        justifyContent: 'center',

        // borderRightColor: defaultThemes.default.divider.default,

      },
    },
    cells: {
      style: {
        '&:not(:last-of-type)': { borderRight: "1px solid black", }// גבולות בין תאים

        // 



        // borderRightStyle: 'solid',
        // borderRightWidth: '1px',
        // borderRightColor: "black",
        // borderTopStyle: "solid",
        // borderTopWidth: "1px",
        // borderTopColor: "black",

        // borderRightColor: defaultThemes.default.divider.default,
      }
      // },
    },
    rows: {
      style: {
        // borderStyle: 'solid',
        //     borderWidth: '1px',
        //     borderColor: "black",
        borderTop: "1px solid black", // גבולות בין שורות

        backgroundColor: '#FFFFFF',
        '&:active': {
          backgroundColor: '#EEEEEE',
        },
      },
    },
  }
  const conditionalRowStyles = [
    {
      when: row => row?.statusQualificationDesc == "פעיל", // תנאי - צביעת שורה עם score מעל 50
      style: {
        backgroundColor: '#d9edf7', // צבע רקע לשורה
        // צבע הטקסט
        '&:hover': {
          cursor: 'pointer',       // אפקט hover
        },
      },

    }, {
      when: row => row?.statusQualificationDesc == "ברישום", // תנאי - צביעת שורה עם score מעל 50
      style: {
        backgroundColor: '#fcf8e3', // צבע רקע לשורה
        color: 'black',             // צבע הטקסט
        '&:hover': {
          cursor: 'pointer',       // אפקט hover
        },
      }
    },
    {
      when: row => row?.statusQualificationDesc == "הסתיים", // תנאי - צביעת שורה עם score מעל 50
      style: {
        backgroundColor: '#dff0d8', // צבע רקע לשורה
        color: 'black',             // צבע הטקסט
        '&:hover': {
          cursor: 'pointer',       // אפקט hover
        },
      }
    },
    {
      when: row => row?.statusQualificationDesc == "בוטל", // תנאי - צביעת שורה עם score מעל 50
      style: {
        backgroundColor: '#ffd3d3', // צבע רקע לשורה
        color: '#333',             // צבע הטקסט
        '&:hover': {
          cursor: 'pointer',       // אפקט hover
        },
      }
    }

  ];
  const downloadExcel = async () => {
    try {
      const response = await axios.get(URL_EXCLE, {
        params: {
          // ...dataFillter
          // member_number:"0001"
        },
        responseType: 'blob', // הגדרת התגובה כ-blob לצורך הורדת הקובץ
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'report.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Error downloading file:', error);
    }

  }

  const handleDetele = async () => {

    await axios.delete(`${GET_DELETE}/${id.id}`).then(response => {
      if (response.status == 200) {
      //  alert("SDA")
        toast.success("המארז נמחק");

        getCases(currentPage - 1)
        
        handleColse()
        // getTrainingDays(currentPage-1)
        // getDFilter()
        console.log("ok")

      }
      else {
        console.log("error")
      }
    })
  }
  const handleColse = () => {
    setModalIsOpen("")
  }

  return (
    <div className='w-full  p-3'>
      <HeaderTable active={"מארזים"} setModalIsOpen={setModalIsOpen}
        // downloadExcel={downloadExcel}
        howmach={fetchData?.length} />
      <DataTable columns={columns} data={fetchData}
        //   pagination
        customStyles={customStyles}
        paginationServer
        // paginationTotalRows={totalRows}
        // onChangeRowsPerPage={handlePerRowsChange}
        // onChangePage={handlePageChange}
        conditionalRowStyles={conditionalRowStyles} // העברת הסגנון המותנה
        progressPending={loading} className='border' >
      </DataTable>
      {/* <Pagination currentPage={currentPage} totalPages={totalRows} onPageChange={handlePageChange} /> */}
      {modalIsOpen == "New" && <ModalNewCase showModal={modalIsOpen == "New"} handleColse={handleColse}
        getDepartment={getCases}
      // getDepartment={getTrainingDays} getDFilter={getDFilter}
      >
      </ModalNewCase>}
      {modalIsOpen == "Edit" && <ModalNewCase showModal={modalIsOpen == "Edit"} handleColse={handleColse}
        getDepartment={getCases}
        //  getDFilter={getDFilter} 
        editData={id}
      >
      </ModalNewCase>}
      {modalIsOpen == "Delete" && <ModalEdit showModal={modalIsOpen == "Delete"} handleColse={handleColse} handleDetele={handleDetele}></ModalEdit>}
      {/* {modalIsOpen == "MoreOptions" && <MoreOptions handleColse={handleColse} row={id}></MoreOptions>} */}

    </div>)
}

export default Case




